import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const Welcome = () => {
  const [isHovered, setIsHovered] = useState(false);
  
  return (
    <div className="pt-6 pb-10">
      <motion.div 
        className="max-w-md mx-auto md:max-w-2xl px-4 text-center"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h1 className="text-2xl font-bold text-primary-700 mb-2">Seu negócio tá crescendo… ou só perdendo dinheiro?</h1>
        <p className="text-lg text-gray-600 mb-6 text-left">
          A maioria dos microempresários quebra não por falta de cliente, mas porque misturam a vida pessoal com a empresa e nunca sabem se tão lucrando ou só girando boleto.
        </p>
        
        <div className="space-y-4 mb-8 text-left">
          <p className="text-gray-700">
            Esse quiz rápido vai revelar o nível de desorganização financeira do seu negócio e te mostrar como sair do caos.
          </p>
          <p className="text-gray-700">
            ⚠️ Se você sente que nunca sobra nada no final do mês, essa é a hora da verdade.
          </p>
          <p className="text-gray-700">
            👉 Clique em Começar e descubra se seu caixa tá saudável ou em coma.
          </p>
        </div>
        
        <Link 
          to="/quiz" 
          className="btn-primary inline-block relative overflow-hidden"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <motion.span
            initial={{ width: '0%' }}
            animate={{ width: isHovered ? '100%' : '0%' }}
            transition={{ duration: 0.3 }}
            className="absolute inset-0 bg-primary-700 z-0"
          />
          <span className="relative z-10">Iniciar</span>
        </Link>
        
        <p className="text-xs text-gray-500 mt-4">
          Leva apenas 60 segundos e pode mudar o futuro do seu negócio
        </p>
      </motion.div>
    </div>
  );
};

export default Welcome;
